import React from "react";
import { wishlistSnackbarActions, WishlistSnackbarType } from "halifax";
import { useDispatch, useSelector } from "react-redux";
import {
  wishlistManagementModalActions,
  WishlistToggleHeart as WishlistToggleHeartComponent,
} from "halifax";
import { wishlistsApi } from "@capone/common";
import { BoxProps } from "@material-ui/core";

interface WishlistHeartToggleProps {
  listingId: string;
  style?: BoxProps;
}

export const WishlistToggleHeart = ({
  listingId,
  style,
}: WishlistHeartToggleProps) => {
  const dispatch = useDispatch();

  const isWishlisted = useSelector(
    wishlistsApi.endpoints.getAllProductIdsByUser.select()
  )?.data?.has(listingId);

  const onAddClick = () => {
    dispatch(
      wishlistManagementModalActions.openModal({ listingId: listingId })
    );
  };

  const onRemoveClick = () => {
    dispatch(
      wishlistSnackbarActions.showSnackbar({
        type: WishlistSnackbarType.REMOVE,
        wishlistId: "",
        listingId: listingId,
      })
    );
  };

  return (
    <WishlistToggleHeartComponent
      isWishlisted={isWishlisted || false}
      style={style}
      listingId={listingId}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
    />
  );
};
